import { type RequiredFileModel, type Stored, type UUID } from "@overmap-ai/common"
import { BaseOfflineFileModelApiService } from "@overmap-ai/core"
import { useCallback } from "react"

import { useFetchFileFromFileModel } from "../../hooks/utils"
import { AppSDK } from "../../sdk"
import type { RootState } from "../../store"
import { genericMemo } from "../../utils/optimization"
import { VideoCard } from "./VideoCard"

interface VideoAttachmentCardProps<TAttachment extends UUID<RequiredFileModel>> {
	attachment: Stored<TAttachment>
	onDelete?: (attachment: Stored<TAttachment>) => void
	service: BaseOfflineFileModelApiService<string, TAttachment, RootState, AppSDK>
}

export const VideoAttachmentCard = genericMemo(function <TAttachment extends UUID<RequiredFileModel>>(
	props: VideoAttachmentCardProps<TAttachment>,
) {
	const { attachment, onDelete, service } = props

	const [fetchedFile, failed] = useFetchFileFromFileModel(attachment, service)

	const handleDelete = useCallback(() => {
		onDelete?.(attachment)
	}, [attachment, onDelete])

	return (
		<VideoCard
			size="sm"
			onDelete={handleDelete}
			file={fetchedFile}
			error={failed ? attachment.file_name : undefined}
		/>
	)
})
